import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { LogOut } from "lucide-react";
import { residentApi, errMsg } from "@/lib/api";
import { useResident } from "@/lib/residentAuth";
import { Card } from "@/components/common";
import { Field, BigInput } from "@/components/form";
import { MyRequests } from "@/pages/resident/MyRequests";
import { MyVisits } from "@/pages/resident/MyVisits";

export default function ResidentProfile() {
  const { resident, logout, reload } = useResident();
  const [f, setF] = useState({ name: resident?.name || "", phone: resident?.phone || "" });
  const save = async () => {
    try {
      await residentApi.patch("/resident/me", { name: f.name || null, phone: f.phone || null });
      await reload();
      toast.success("Saved");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Profile</h1>
      <Card className="p-4 space-y-3" data-testid="resident-profile-card">
        <Field label="Email"><BigInput data-testid="rp-email-input" value={resident?.email || ""} disabled /></Field>
        <Field label="Name"><BigInput data-testid="rp-name-input" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></Field>
        <Field label="Mobile number"><BigInput data-testid="rp-phone-input" inputMode="numeric" maxLength={10} value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value.replace(/\D/g, "") })} /></Field>
        <Button data-testid="rp-save-btn" onClick={save} className="w-full h-12 rounded-xl bg-[#131e2e] hover:bg-[#0b1320]">Save</Button>
      </Card>
      <MyVisits />
      <MyRequests />
      <button data-testid="rp-logout-btn" onClick={logout} className="w-full h-14 rounded-2xl border border-slate-200 bg-white font-semibold text-rose-600 flex items-center justify-center gap-2 pg-tap">
        <LogOut className="h-4 w-4" />Log out
      </button>
    </div>
  );
}
